import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import LayoutOne from "../layouts/LayoutOne";
import SectionHeroBanner from "../components/Common/SectionHeroBanner";
import MainTitle from "../components/Common/MainTitle";
import SectionOngoingProject from "components/Project/SectionOngoingProject";
import SectionCompletedProjects from "components/Project/SectionCompletedProjects";

const placeholderCases = [
  {
    title: "Rig crew surge for offshore campaign",
    problem: "Operator needed vetted drill-floor and maintenance crews within a compressed mobilisation window.",
    solution: "SAC deployed multi-discipline crews with aligned HSE documentation and travel logistics.",
    results: "Zero LTI across rotation; on-time spud with full competency verification.",
  },
  {
    title: "Workover campaign acceleration",
    problem: "Workover rigs idle due to specialist shortages in remote basin.",
    solution: "Dedicated sourcing cell + rapid mobilisation corridors from Mumbai and Ahmedabad hubs.",
    results: "Reduced NPT days and restored planned completion schedule.",
  },
];

const ProjectsCaseStudies = () => (
  <Fragment>
    <MetaTags>
      <title>Projects & Case Studies | South Asia Consultancy</title>
      <meta
        name="description"
        content="Ongoing projects, completed work, and case studies from South Asia Consultancy oilfield operations."
      />
    </MetaTags>
    <LayoutOne>
      <SectionHeroBanner title="Projects & Case Studies" className="sectionProjectBg" />
      <SectionOngoingProject />
      <SectionCompletedProjects />
      <div className="container py-5 sac-page-shell">
        <MainTitle text="Case Studies" className="text-center" position="center" width="160px" />
        <p className="text-center fs18px fw500 mb-5 sac-intro">
          Structured narratives highlight the problem we solved, the solution architecture, and measurable results for operators.
        </p>
        <div className="row">
          {placeholderCases.map((c) => (
            <div key={c.title} className="col-md-6 mb-4">
              <article className="sac-content-card h-100">
                <h2 className="MainTitle" style={{ fontSize: "20px" }}>
                  {c.title}
                </h2>
                <p className="fs15px mb-2">
                  <strong>Problem:</strong> {c.problem}
                </p>
                <p className="fs15px mb-2">
                  <strong>Solution:</strong> {c.solution}
                </p>
                <p className="fs15px mb-0">
                  <strong>Results:</strong> {c.results}
                </p>
              </article>
            </div>
          ))}
        </div>
      </div>
    </LayoutOne>
  </Fragment>
);

export default ProjectsCaseStudies;
